import React from 'react';
import { Flame } from 'lucide-react';

export default function Footer({ lang }) {
  const t = {
    copyright: lang === 'bg'
      ? `© ${new Date().getFullYear()} SportAppPros. Всички права запазени.`
      : `© ${new Date().getFullYear()} SportAppPros. All rights reserved.`,
    links: lang === 'bg'
      ? [
          { label: 'Контакт', href: '/kontakt.html' },
          { label: 'ЧЗВ', href: '/faq.html' },
          { label: 'Условия', href: '/terms.html' },
        ]
      : [
          { label: 'Contact', href: '/kontakt.html' },
          { label: 'FAQ', href: '/faq.html' },
          { label: 'Terms', href: '/terms.html' },
        ],
    tagline: lang === 'bg'
      ? 'SportAppPros — спортно представяне за истински атлети. Направено в България.'
      : 'SportAppPros — sports performance for real athletes. Made in Bulgaria.',
  };

  return (
    <footer className="bg-[#0a1120] border-t border-slate-800/60 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top row */}
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8 mb-12">
          {/* Logo */}
          <div>
            <a href="/" className="flex items-center gap-2 mb-3">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-orange-500 to-amber-400 flex items-center justify-center shadow-lg shadow-orange-500/30">
                <Flame className="w-5 h-5 text-white" />
              </div>
              <span className="text-2xl font-black tracking-tight">
                <span className="text-orange-500">Sport</span>
                <span className="text-white">App</span>
                <span className="text-amber-400">Pros</span>
              </span>
            </a>
            <p className="text-slate-500 text-sm max-w-xs">{t.tagline}</p>
          </div>

          {/* Links */}
          <nav className="flex flex-wrap justify-center md:justify-end gap-6">
            {t.links.map((link, i) => (
              <a
                key={i}
                href={link.href}
                className="text-slate-500 hover:text-orange-400 transition-colors text-sm font-semibold tracking-wide uppercase"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-slate-700/60 to-transparent mb-8" />

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-slate-600 text-xs">
          <span>{t.copyright}</span>
          <div className="flex items-center gap-1">
            <span>{lang === 'bg' ? 'Направено с' : 'Made with'}</span>
            <span className="text-orange-500 font-bold">♥</span>
            <span>{lang === 'bg' ? 'в България' : 'in Bulgaria'}</span>
            <span>🇧🇬</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
